// src/pages/Skills.jsx

import React from 'react';
import './Skills.css';
import GeometricDivider from '../components/GeometricDivider';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { skillCategories } from '../data/skills';

function ProficiencyDots({ level }) {
  return (
    <span className="proficiency-dots" aria-hidden="true">
      {[1, 2, 3].map((i) => (
        <span key={i} className={`dot ${i <= level ? 'filled' : ''}`} />
      ))}
    </span>
  );
}

export default function Skills() {
  useDocumentTitle('Skills', 'Languages, frameworks, and tools Arian Kazemi works with — React, Node.js, cloud platforms, and computer science fundamentals.');

  return (
    <>
      <section className="hero">
        <div className="hero-content page-container">
          <h1>Skills</h1>
          <p className="tagline">Technologies, tools, and fundamentals I work with</p>
        </div>
      </section>
      <GeometricDivider />

      <section className="skills-section page-container">
        <div className="skills-grid">
          {skillCategories.map((cat) => (
            <div key={cat.title} className="skill-card card">
              <div className="skill-icon">{cat.icon}</div>
              <h3>{cat.title}</h3>
              <ul>
                {cat.skills.map((s) => (
                  <li key={s.name}>
                    <span className="skill-name">{s.name}</span>
                    <ProficiencyDots level={s.level} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <GeometricDivider />
    </>
  );
}
